<template>
  <tr
    :class="{ 'sortable-disabled': stage.fixed }">
    <td
      class="text-truncate"
      width="10">
        <a
          href="javascript:void(0)"
          class="sortable-move text-secondary"
          v-if="!stage.fixed"><i class="fas fa-arrows-alt" />
        </a>
    </td>
    <td class="text-truncate">
        <a href="javascript:void(0)" v-if="!stage.fixed" @click="showEditModal('form', stage)">{{ stage.name }}</a>
        <span v-if="stage.fixed">{{ stage.name }}</span>
        <StageForm
          v-if="modal_select === 'form'"
          :initStage="modal_data" 
          @hideModal="hideModal()"
          @deleted="hideModal(true)" 
          @saved="hideModal(true)" />
    </td>
    <td class="text-truncate">{{ stageTypes[stage.type] }}</td>
    <td class="text-truncate"><strong :class="{'text-success': stage.default}">{{ stage.default ? $t('Yes') : $t('No') }}</strong></td>
    <td class="text-truncate"><strong :class="{'text-success': stage.active}">{{ stage.active ? $t('Yes') : $t('No') }}</strong></td>
    <td class="text-truncate">
      <div v-if="resourceAvailability.features.includes('automated_triggers')">
        <button
          type="button"
          class="btn btn-sm btn-link"
          v-if="!actionsLength"
          @click="showEditModal('actions', stage)"><i class="fas fa-bolt"></i> {{ $t('Add actions') }}</button>
        <button
          type="button"
          class="btn btn-sm btn-outline-primary"
          v-if="actionsLength"
          @click="showEditModal('actions', stage)"><i class="fas fa-bolt"></i> {{ $tc('n_actions', actionsLength) }}</button>
      </div>
      <div v-if="!resourceAvailability.features.includes('automated_triggers')">
        <span v-tooltip="'Faça upgrade do plano'"><button
          type="button"
          class="btn btn-sm btn-link"
          style="pointer-events: none;"><i class="fas fa-bolt"></i> {{ $t('Add actions') }}</button></span>
      </div>
      <StageActionForm
        v-if="modal_select === 'actions'"
        :value="modal_data.actions"
        @cancel="hideModal()"
        @input="updateActions" />
    </td>
  </tr>
</template>

<script>
import StageActionForm from './StageActionForm'
import StageForm from './StageForm'

export default {
  name: 'StageItem',
  components: {
    StageActionForm,
    StageForm
  },
  props: {
    stage: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      modal_select: false,
      modal_data: false
    }
  },
  created () {
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    actionsLength () {
      return this.stage.actions ? this.stage.actions.length : 0
    },
    stageTypes () {
      return {
        'applied': this.$t('Application'),
        'sourced': 'Triagem',
        'phone-screen': 'Contato por telefone',
        'shortlist': 'Shortlist',
        'interview': 'Entrevista',
        'offer': 'Oferta',
        'hired': 'Contratado'
      }
    }
  },
  methods: {
    showEditModal (type, item) {
      this.modal_select = type
      this.modal_data = item
    },
    hideModal (refresh) {
      this.modal_select = this.modal_data = false
      if (refresh) {
        this.$emit('refresh')
      }
    },
    /*
    updateStage
    */
    updateActions (actions) {
      return this.$store.dispatch('updateStageActions', {
        _id: this.stage._id,
        actions
      }).then(() => {
        this.hideModal(true)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Stage/StageItem.vue